const css = `._9RRNIG__noWrap{text-overflow:ellipsis;white-space:nowrap;color:#3a4b59;overflow:hidden}._9RRNIG__noWrap._9RRNIG__inverse{color:#fff}._9RRNIG__noUnderline a:hover{text-decoration:none}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"inverse":"_9RRNIG__inverse","noWrap":"_9RRNIG__noWrap","noUnderline":"_9RRNIG__noUnderline"};
